export const DESCRIPTION_SAVE_ERROR = 'Your description wasn’t saved. Your changes are still here; try again.';
/** Shared save lifecycle for React and the isolated ES2017 Figma UI. */
export class OptionalDescriptionController {
    onSave;
    state;
    source;
    listeners = new Set();
    disposed = false;
    constructor(value, onSave) {
        this.onSave = onSave;
        this.source = value;
        this.state = { saved: value, draft: value, editing: false, pending: false, error: false };
    }
    getSnapshot = () => this.state;
    subscribe = (listener) => {
        this.listeners.add(listener);
        return () => { this.listeners.delete(listener); };
    };
    update(patch) {
        if (this.disposed)
            return;
        this.state = { ...this.state, ...patch };
        this.listeners.forEach(listener => listener());
    }
    setValue(value) {
        if (value === this.source)
            return;
        this.source = value;
        this.update({ saved: value });
    }
    edit = () => { this.update({ editing: true, draft: this.state.saved, error: false }); };
    cancel = () => { if (!this.state.pending)
        this.update({ editing: false, error: false }); };
    setDraft = (draft) => { this.update({ draft, error: false }); };
    save = async () => {
        if (this.state.pending || this.state.draft === this.state.saved)
            return;
        const submitted = this.state.draft;
        this.update({ pending: true, error: false });
        try {
            await this.onSave(submitted);
            this.update({ saved: submitted, editing: this.state.draft !== submitted });
        }
        catch {
            this.update({ error: true });
        }
        finally {
            this.update({ pending: false });
        }
    };
    dispose() { this.disposed = true; this.listeners.clear(); }
}
//# sourceMappingURL=optionalDescriptionEditor.js.map